import React from 'react';
import PropTypes from 'prop-types';

import CheckBox from 'components/CheckBox';
import ScatterPlot from 'components/ScatterPlot';

const ScatterPlotComponent = props =>
  <main>
    <div className="text-right">
      <CheckBox
        onChange={props.onCheckboxChange}
        checked={props.showRegressionLine}
      >
        Regression Line
      </CheckBox>
    </div>

    <div className="mb-30">
      <ScatterPlot {...props} />
    </div>
  </main>;

ScatterPlotComponent.propTypes = {
  showRegressionLine: PropTypes.bool.isRequired,
  onCheckboxChange: PropTypes.func.isRequired
};

export default ScatterPlotComponent;
